//Dependencies............................................
import React from "react";
import { Button, Modal} from 'antd';


//Components..............................................


interface Props {
    showApiKeyModal: boolean,
    toggleApiModal: () => void,
    apiKey: string,
}

const ShowApiKeyModal: React.FC<Props> = ({
    showApiKeyModal,
    toggleApiModal,
    apiKey,
}: Props) => {

    return(
        <Modal
            open={showApiKeyModal}
            onCancel={toggleApiModal}
            title="API Key"
            footer={[
                <Button type="default" onClick={toggleApiModal}>Close</Button>,
            ]}
        >
            <h2>API Key</h2>
            <p>{apiKey}</p>
            <p>
                This key can be set one time only and cannot be viewed afterwards.
                Please save it to a secure location.
            </p>
        </Modal>
    )
}

export default ShowApiKeyModal;